<template>
  <div class="anketa-2cols">
    <span class="title">
      Выбери свой цвет кожи. Подсказка, как понять свой подтон
      <a @click='showModal();commonEvents()'>здесь</a>
    </span>
    <div>
      <SkinBlock :data="datas"
                 @isSelected="isSelected()"
      />
    </div>
    <primary-button
        @click="saveStep(button.link); events();"
        :disabled="disabled"
        :text="button.text"
        :link="button.link"/>
  </div>
  <anketa-modal ref="modal"
                :content="modal.content"
                :btn-text="modal.btnText"/>
</template>

<script>
import SkinBlock from "@/components/Anketa/SkinBlock";
import skinData from "@/data/anketa/skinData";
import {useHeaderStore} from '@/stores/header'
import AnketaModal from "@/components/UI/AnketaModal";
import headerMixin from "@/mixins/headerMixin";
import {useSettingsStore} from "@/stores/settings";
import selectedMixin from "@/mixins/selectedMixin";
import {useApiStore} from "@/stores/api";
import {useAnketaStore} from "@/stores/anketa";

export default {
  name: 'SkinQuestionView',
  components: {AnketaModal, SkinBlock},
  mixins: [headerMixin, selectedMixin],
  props: ['header'],
  setup() {
    const {setHeaderData} = useHeaderStore();
    const settings = useSettingsStore();
    const api = useApiStore();
    const anketaStore = useAnketaStore();
    return {setHeaderData, settings,api, anketaStore};
  },
  methods: {
    showModal: function () {
      this.$refs.modal.show = true
    },
    async commonEvents(){
      let data = {"stage":"question_3"}
      await this.api.commonEvent('onHintRequest', data);
    },
    async events() {
      const isEdit = this.anketaStore.isFinished();
      const fromPage = this.anketaStore.formFromPage ?? null;
      await this.api.onStageEvent('onFormStage', 'question_4', isEdit ? false : null, fromPage);
    }
  },
  data() {
    return {
      stepId: 'skin_tone',
      button: {
        text: 'Продолжить',
        link: 'anketa.step4',
      },
      modal: {
        content: "<div class='title'>Как определять подтон</div>" +
            "<p>Посмотри на цвет вен: если они фиолетово-голубые, то твой подтон холодный, а если зелёные - теплый.</p>" +
            "<div class='title'>Как определить цвет кожи</div>" +
            "<p>Ориентируйся на то, как на тебя ложится загар и какой цвет тонального крема ты выбираешь. Чем скорее ты обгораешь на солнце и чем светлее твой тональный крем, тем более светлый у тебя цвет кожи. И наоборот.</p>",
        btnText: "Поняла",
      }
    }
  }
}
</script>
